export const OrderFlags = {
	IS_SERVICE_CHANGED: 1,
};
